import React, { Component } from 'react'

import firebase from '../firebase.js'

export class InfoPanelPage extends Component {
    constructor() {
        super()
        this.state = {
            infoPanel: null,
        }
        this.scenarioTimeRef = undefined
        this.rememberedTimeCallback = undefined
    }

    componentDidMount() {
        const itemsRef = firebase
            .database()
            .ref(`infoPanel/${this.props.match.params.panelId}/`)

        itemsRef.on('value', snapshot => {
            let item = snapshot.val()
            this.setState({
                infoPanel: item,
            })
        })

        // read query params and then follow table or scenario
        let params = new URLSearchParams(window.location.search)
        let tableName = params.get('table')
        let scenarioName = params.get('scenario')
        let controlName = params.get('control')
        if (tableName) {
            this.listenToTable(tableName)
        } else if (scenarioName) {
            this.listenToScenarioTime(scenarioName)
        } else if (controlName) {
            this.listenToControl(controlName)
        } else {
            this.setState({
                errorMessage:
                    'not following table or scenario. Try ?table=cody_localhost in the adress ',
            })
            //console.log('%c !!! Not Following a Table !!!', 'background: black; color: red; display: block;');
        }
    }

    listenToTable(tableName) {
        var tableRef
        console.log('following table', tableName)
        tableRef = firebase
            .database()
            .ref('deviceRegistration')
            .child(tableName)
            .child('scenarioID')
        tableRef.on('value', ev => {
            let val = ev.val()
            if (!val) {
                this.setState({
                    errorMessage:
                        'ScenrioID was empty. Maybe the table ID was wrong',
                })
                // console.log('%c ScenrioID was empty. Maybe the table ID was wrong ', 'background: black; color: red; display: block;');
                return
            }
            this.setState({ scenarioID: val })
            this.listenToScenarioTime(val)
        })
    }

    listenToScenarioTime(scenarioID) {
        console.log('listening to scnario time from:', scenarioID)
        if (this.scenarioTimeRef)
            this.scenarioTimeRef.off('value', this.rememberedTimeCallback)
        this.scenarioTimeRef = firebase
            .database()
            .ref('scenarios')
            .child(scenarioID)
            .child('models')
            .child('modelTime')
        this.rememberedTimeCallback = this.scenarioTimeRef.on('value', ev2 => {
            let val2 = Number(ev2.val())
            console.log('time', val2)
            this.setState({ modelTime: val2 })
        })
    }

    listenToControl(controlName) {
        console.log('listening to control time from:', controlName)
        this.controlRef = firebase
            .database()
            .ref('InfoPanelControls')
            .child(controlName)
        this.controlRef.on('value', control => {
            const val = control.val()
            this.setState({ control: val })
        })
    }

    getSlide() {
        const a = this.state.infoPanel.slides
        const modelTime = this.state.modelTime || 0
        const currentSlide =
            (this.state.control && this.state.control.currentSlide) || -1

        if (currentSlide >= 0) {
            let slideKeys = Object.keys(a)
                .map(v => Number(v))
                .sort((x, y) => x - y)
            const slideKey = currentSlide % slideKeys.length
            if (
                slideKeys.length - 1 > this.state.control.maxSlides ||
                this.state.control.maxSlides === undefined
            ) {
                this.controlRef.update({ maxSlides: slideKeys.length - 1 })
            }
            if (this.state.control.minSlides === undefined) {
                this.controlRef.update({ minSlides: 0 })
            }
            return a[slideKeys[slideKey]]
        }

        let slideKeys = Object.keys(a)
            .map(v => Number(v))
            .sort((x, y) => x - y)
        let key = slideKeys.filter(x => x <= modelTime).pop()
        console.log({ modelTime, slideKeys, key })
        return a[key] || this.state.infoPanel.defaultSlide
    }

    render() {
        console.log('infoPanel', { state: this.state, props: this.props })

        let content = <div className="content" />
        let infoPanel = this.state.infoPanel

        if (infoPanel) {
            let defaultSlide = infoPanel.defaultSlide
            console.log({ defaultSlide })
            let slide = this.getSlide()

            content = (
                <div className="content-body">
                    <style type="text/css">
                        {slide.css || defaultSlide.css}
                    </style>
                    <div
                        className="content"
                        dangerouslySetInnerHTML={{
                            __html: slide.html || defaultSlide.html,
                        }}
                    />
                </div>
            )
        }

        return (
            <div>
                <div>{this.props.errorMessage}</div>
                {content}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/InfoPanelPage.js